/**
 * Toast "Você está sem conexão" — global, registrado via main.js.
 *
 * Decisão consciente:
 * - Usamos APENAS os eventos `offline`/`online` do browser.
 * - `navigator.onLine === false` é confiável quando true: se o browser diz
 *   "offline", está realmente offline. O contrário (true) pode mentir, mas
 *   isso só é problema em sinalizar AUSÊNCIA — e neste toast só nos importa
 *   sinalizar PRESENÇA de offline, então o risco é só não mostrar em casos
 *   raros (captive portal etc.), nunca mostrar um falso positivo.
 * - NÃO usamos polling HTTP: gera ruído, falsos positivos em dev/localhost,
 *   e disputa com o servidor. Para detecção fina dentro da página de lote,
 *   usamos o estado do WebSocket no `websocket.store.js`.
 */
export function setupGlobalOfflineToast() {
  if (typeof window === 'undefined') return

  let toastRef = null

  function showToast() {
    if (toastRef) return
    const G = window.GLOBAL
    if (!G?.toastifyOffline) return
    toastRef = G.toastifyOffline()
  }

  function hideToast() {
    toastRef?.hideToast?.()
    toastRef = null
  }

  function sync() {
    if (navigator.onLine === false) showToast()
    else hideToast()
  }

  window.addEventListener('offline', sync)
  window.addEventListener('online', sync)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true })
  } else {
    sync()
  }
}
